import axios from "axios";
import router from "@/router";
import store from "../store/index";
import HTTPREQUEST from "@/config/app";
import Storage from "@/utils/Storage";
import { Message } from 'element-ui';

const service = axios.create({
  // baseURL: HTTPREQUEST.HTTPREQUESTURL,
  timeout: 15000, // request timeout
});

//添加拦截器
// 请求拦截  =>  在请求发送之前进行拦截, 常用于修改数据,配置请求头(携带token)
// 响应拦截  =>  在服务端返回响应,响应被 then 或 catch 接收前拦截它们
service.interceptors.request.use(
  function (config) {
    // console.log(config ,'config');
    var token = store.state.token;
    var uid = store.state.uid;
    // console.warn(token, "token");
    if (token) {
      config.headers["uid"] = uid;
      config.headers["Authori-zation"] = "Bearer " + token;
      config.headers["Content-Type"] = "application/json; charset=utf-8";
      // 上传excel
      if (config.url == 'merchant/order/importExcel') {
        config.headers["Content-Type"] = 'multipart/form-data';
      }
    }

    // config.data.timestamp = Math.floor(new Date().getTime() / 1000)
    config.url = "/apvi/" + config.url;
    // console.warn(config.data, "config");
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
// 目的: 请求成功,操作成功 -> 走then
//       只要有一个失败  -> 走catch  -> 将所有的错误整合到一起-> 统一处理
service.interceptors.response.use(
  function (response) {
    let { status, message } = response.data;

    if (status == 200) {
      return response.data;
    } else if (status == 400) {
      // console.error(response.data || "Error")
      return response.data;
    } else if (status == 410000) {
      store.commit("CLEAR_STATE");
      // router.replace("/login"); 
      // console.error(response.data || "Error")
      return response.data;
    } else {
      let err = new Error(message);
      return Promise.reject(err);
    }
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default service;
